import { atom } from 'jotai';

export const tasksState = atom([]);

export const scheduleEntriesState = atom([]);

export const supervisorsListState = atom([]);

export const supervisorAssignmentDaysState = atom({});

export const contractorsState = atom([]);

export const branchesState = atom([]);

// 작업 지시 상태 추가
export const workOrdersState = atom({
  'todo': {
    name: 'To Do',
    items: []
  },
  'in-progress': {
    name: 'In Progress',
    items: []
  },
  'review': {
    name: 'Review',
    items: []
  },
  'done': {
    name: 'Done',
    items: []
  }
});